export const HOSTNAME = 'https://redbark-api.onrender.com/api';
export const UPLOADHOST = 'https://redbark-api.onrender.com';
export const SCROLLSPEED = 0.07;

export const WIDE = 10000;
export const LG_TABLET = 1200;
export const TABLET = 768;
export const LG_MOBILE = 674;
export const MOBILE = 396;